import React from 'react';
import { SearchField } from '@/components/custom/erp';
import { FormField } from '@/components/custom/erp';
import { customerSearchColumns, QUERY_KEYS } from '@/constants';
import type { KhachHang } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface FormDialogProps {
  formMode: FormMode;
  customer: KhachHang | null;
  setCustomer: (customer: KhachHang) => void;
}

const FormDialog: React.FC<FormDialogProps> = ({ formMode, customer, setCustomer }) => {
  const isViewMode = formMode === 'view';

  return (
    <div className='max-h-[calc(100vh-150px)] space-y-4 overflow-y-auto p-4'>
      {/* Mã khách hàng - Customer Code with search */}
      <div className='flex items-center'>
        <Label className='min-w-40'>Mã khách hàng</Label>
        <SearchField<KhachHang>
          type='text'
          displayRelatedField={'customer_name'}
          columnDisplay={'customer_code'}
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}`}
          searchColumns={customerSearchColumns}
          dialogTitle='Danh mục khách hàng'
          value={customer?.customer_code || ''}
          relatedFieldValue={customer?.customer_name || ''}
          onRowSelection={setCustomer}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      {/* Mã địa chỉ */}
      <div className='flex items-center'>
        <Label className='min-w-40'>Mã địa chỉ</Label>
        <FormField type='text' name='ma_dc' className='w-full' disabled={isViewMode} />
      </div>

      {/* Địa chỉ */}
      <div className='flex items-center'>
        <Label className='min-w-40'>Địa chỉ</Label>
        <FormField type='text' name='ten_dc' className='w-full' disabled={isViewMode} />
      </div>

      {/* Địa chỉ khác */}
      <div className='flex items-center'>
        <Label className='min-w-40'>Địa chỉ khác</Label>
        <FormField type='text' name='ten_dc2' className='w-full' disabled={isViewMode} />
      </div>

      {/* Người liên hệ - Contact Person */}
      <div className='flex items-center'>
        <Label className='min-w-40'>Người liên hệ</Label>
        <FormField type='text' name='lien_he_gh' className='w-full' disabled={isViewMode} />
      </div>

      {/* Điện thoại - Phone */}
      <div className='flex items-center'>
        <Label className='min-w-40'>Điện thoại</Label>
        <FormField type='text' name='dt_gh' className='w-full' disabled={isViewMode} />
      </div>

      {/* Fax */}
      <div className='flex items-center'>
        <Label className='min-w-40'>Fax</Label>
        <FormField type='text' name='fax_gh' className='w-full' disabled={isViewMode} />
      </div>

      {/* Ghi chú - Notes */}
      <div className='flex items-center'>
        <Label className='min-w-40'>Ghi chú</Label>
        <FormField type='text' name='ghi_chu' className='w-full' disabled={isViewMode} />
      </div>

      <div className='flex items-center'>
        <Label htmlFor='status' className='min-w-40'>
          Trạng thái
        </Label>
        <FormField
          id='status'
          type='select'
          name='status'
          className='w-full'
          disabled={isViewMode}
          options={[
            { value: '1', label: '1. Còn sử dụng' },
            { value: '0', label: '0. Không sử dụng' }
          ]}
        />
      </div>
    </div>
  );
};

export default FormDialog;
